import { z } from 'zod';

import { IAppDetailsSchema } from './IAppDetails';

export interface IAppIconWriteSuccessResult {
  type: 'success';
}
export interface IAppIconWriteErrorResult {
  type: 'error';
  errorType: 'networkError' | 'invalidImage' | 'unknownError';
  errorMessage: string;
}

export type IAppIconWriteResult = IAppIconWriteSuccessResult | IAppIconWriteErrorResult;
export interface IAppIconWriter {
  updateAppIcon(appId: string, icon: Blob, type: 'color' | 'outline'): Promise<IAppIconWriteResult>;
  deleteAppIcon(appId: string, type: 'color' | 'outline'): Promise<IAppIconWriteResult>;
}


// This is part of a larger, far more horrible hack that should be solved by the API not forcing us to keep
// its internal models consistent.
// For the time-being we need these urls (which are internal only) so we can correctly write-back the values to the service
// to avoid getting into an inconsistent state.
export const ImageDefinitionsDtoSchema = IAppDetailsSchema.extend({
  colorIcon: z.string(),
  outlineIcon: z.string()
});

export type IImageDefinitionsDto = z.infer<typeof ImageDefinitionsDtoSchema>;
